var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.569,
    height: 57.569,
    viewBox: "0 0 57.569 57.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.838,
    y1: 0.135,
    x2: 0.041,
    y2: 1.21,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31beef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f4fd1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15334",
    x: 0,
    y: 0,
    width: 57.569,
    height: 57.569,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1962",
    "data-name": "Rectangle 1962",
    width: 19.908,
    height: 19.927,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783",
    transform: "translate(9 45.569) rotate(-90)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_461",
    "data-name": "Ellipse 461",
    cx: 14.236,
    cy: 14.236,
    rx: 14.236,
    ry: 14.236,
    transform: "translate(5.608 5.608)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0, 1, -1, 0, 45.57, -9)",
    filter: "url(#Path_15334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15334-2",
    "data-name": "Path 15334",
    d: "M38.382,18.6H35.736A16.026,16.026,0,0,0,20.96,3.819V1.187a1.187,1.187,0,1,0-2.374,0V3.819A16.027,16.027,0,0,0,3.808,18.6H1.187a1.187,1.187,0,1,0,0,2.374H3.808A16.027,16.027,0,0,0,18.585,35.75v2.632a1.187,1.187,0,1,0,2.374,0V35.75A16.026,16.026,0,0,0,35.736,20.971h2.646a1.187,1.187,0,1,0,0-2.374ZM19.772,33.435A13.651,13.651,0,1,1,33.424,19.784,13.651,13.651,0,0,1,19.772,33.435Zm0,0",
    transform: "translate(9 45.57) rotate(-90)",
    fill: "#0e4fd1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616",
    transform: "translate(29.97 29.632) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5831",
    "data-name": "Group 5831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M15.724,15.119l3.055-2.282c.318-.026,1.115,1.013,1.13,1.379-.856.881-1.391,2.012-2.213,2.917-1.016,1.119-2.4,1.767-3.5,2.8-.349-.013-1.437-.862-1.37-1.176l2.27-2.973L10.19,12.056,2.027,17.894a6.077,6.077,0,0,1-1.715-.98.784.784,0,0,1-.241-.919A12.945,12.945,0,0,1,1.36,14.443c1.3-1.5,2.931-3.035,4.105-4.6a4.464,4.464,0,0,0,.4-.593c.139-.264.407-.808.291-1.077A11.24,11.24,0,0,1,4.279,5.658c-.124-.38.138-.4.138-.569,0-.073-.28-.478-.328-.66-.236-.9.754-.02.986,0,.143.013.216-.27.622-.128A9.223,9.223,0,0,1,7.348,5.431c.271.217.713.839,1.084.777a4.555,4.555,0,0,0,1.386-.719c1.567-1.173,3.1-2.808,4.6-4.105A13.486,13.486,0,0,1,16,.066c.635-.321,1.191.616,1.453,1.061.131.223.47.741.39.964l-5.823,8.124Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPlane);
export default __webpack_public_path__ + "static/media/map-plane.46e9d9caf14c588a30a353ac70c346a8.svg";
export { ForwardRef as ReactComponent };